import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { OutputDataObjectProcessingUpdateType } from '../schema/types';
import { OutputDataUrl } from './OutputDataUrl';
import { OutputDataObjectProcessingUpdatesSchema } from '../schema/OutputDataObjectProcessingUpdatesSchema';

const getOutputDataRefreshAggregates = (ids?: number[]) =>
  apiClient
    .get<
      Array<OutputDataObjectProcessingUpdateType>
    >(expand(OutputDataUrl.OUTPUT_DATA_GROUP_PROCESSING_STATES_REFRESH, { ids }))
    .then((response) =>
      OutputDataObjectProcessingUpdatesSchema.parse(response.data),
    );

const queryKey = ['outputDataRefreshAggregates'] as const;

export const useOutputDataGroupProcessingStateRefreshQuery = createApiQueryHook(
  queryKey,
  getOutputDataRefreshAggregates,
);

export const useRemoveOutputDataAggregateRefreshQueries = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () =>
      queryClient.removeQueries({
        queryKey,
        exact: false,
      }),
    [queryClient],
  );
};
